import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { reservaPeriodoService } from "../services/reservaPeriodoService";

// --------------------- Import Interfaces ---------------------
import { DataTypeReserva } from "../interfaces/DataTypeReserva";

export const useReservaPeriodo = (
  periodoUsuarioId: number | null | undefined
) => {
  const [reservaPeriodo, setReservasPeriodoService] = useState<
    DataTypeReserva[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReservas = async () => {
      const data = await reservaPeriodoService(periodoUsuarioId);
      setReservasPeriodoService(data);
      setIsLoading(false);
    };

    fetchReservas();
  }, [periodoUsuarioId]);

  return { reservaPeriodo, isLoading };
};
